export default "__VITE_ASSET__29uElbvZ__";